import React from 'react';
import Navbar from "./components/Navbar.jsx";
import Hero from "./components/Hero.jsx";
import Footer from "./components/Footer.jsx";
import Product from "./components/Product.jsx";

function App() {
  return (
    <div >
     <Navbar />  
     <Hero />
     <Product />
     <Footer />
    </div>
  );
}

export default App;
